import { render } from "./IconEdit.vue?vue&type=template&id=960c3df2"
const script = {}
script.render = render

export default script